import { Attendance, AttendanceTable } from '@/modules/attendance/entities/attendance';
import { STATUS } from '@/modules/attendance/entities/status';
import formatText from '@/utils/formatText';

export const normalizeAttendances = (attendances: Attendance[]): AttendanceTable[] => {
  if (!attendances || !attendances.length) {
    return [];
  }

  return attendances.map((attendance: Attendance): AttendanceTable => {
    const { id, subject, createdAt, status, expectedSolutionTime, reason, updatedAt } = attendance;
    let forecast = 'Em análise';

    if (expectedSolutionTime) {
      forecast =
        Number(expectedSolutionTime) > 1
          ? `${expectedSolutionTime} dias úteis`
          : `${expectedSolutionTime} dia útil`;
    }

    return {
      id: id || '',
      subject,
      createdAt: formatText(createdAt || '', 'dateWithoutTZ'),
      status: status as STATUS,
      forecast,
      reason,
      updatedAt: formatText(updatedAt || '', 'dateWithoutTZ'),
    };
  });
};
